import React from "react";

interface Props {
  joint: { name: string; img: string };
}

export const JointRow: React.FC<Props> = ({ joint }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%"}}>
      <span style={{ marginRight: 12, fontWeight: "bold" }}>
        {joint.name}
      </span>
      <div
        style={{
          flex: 1,
          height: 28,
          backgroundImage: `url(${joint.img})`,
          backgroundSize: "auto 100%",
          backgroundRepeat: "repeat-x",
          borderRadius: 4,
          margin: "3px 0",
        }}
      />
    </div>
  );
};
